export default __webpack_public_path__ + "static/media/FotovanBeek_logo_350.cc558d2d.jpg";